import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 1,
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: { type: "image", options: { src: `${config.ASSETS_URL}/01/21/principle/left-1-650.png` } },
                styles: { padding: "5%" },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: { type: "image", options: { src: `${config.ASSETS_URL}/01/21/principle/right-1-650.png` } },
                styles: { padding: "5%" },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
